<div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-6">
  <img src="/assets/illustration/logo_sad.svg" width="76" height="82" />
  <h1 class="tw:xl:text-[4rem]! tw:lg:text-[3rem]! tw:md:text-xxl! tw:text-center tw:m-0! text-xl!">
    {{ "booking_app.error.title" | translate }}
  </h1>
</div>
<div class="tw:text-xl tw:max-w-136 tw:text-center tw:font-normal">
  {{ "booking_app.error.description" | translate }}
</div>
<div
  class="tw:max-w-155 tw:w-full tw:rounded-2xl tw:border tw:border-gray-20 tw:p-4 tw:md:py-8 tw:md:px-10 tw:flex tw:flex-col tw:gap-4"
>
  <h2 class="tw:font-semibold tw:text-lg! tw:xl:text-[1.75rem]! tw:m-0!">
    {{ "booking_app.error.what_you_can_do" | translate }}
  </h2>
  <div class="tw:flex tw:gap-2 tw:items-center tw:text-lg tw:xl:text-[1.5rem]!">
    <span class="tw:rounded-full tw:size-2 tw:bg-dark-green"></span>
    <span>{{ "booking_app.error.make_sure_the_link_is_typed_correctly" | translate }}</span>
  </div>
  <div class="tw:flex tw:gap-2 tw:items-center tw:text-lg tw:xl:text-[1.5rem]!">
    <span class="tw:rounded-full tw:size-2 tw:bg-dark-green"></span>
    <span>{{ "booking_app.error.verify_the_link_with_the_person_who_shared_it" | translate }}</span>
  </div>
  <div class="tw:flex tw:gap-2 tw:items-center tw:text-lg tw:xl:text-[1.5rem]!">
    <span class="tw:rounded-full tw:size-2 tw:bg-dark-green"></span>
    <a href="https://calfrenzy.com">{{ "booking_app.error.return_to_the_homepage" | translate }}</a>
  </div>
</div>
